import * as amplify from "../util/amplify.ts";
import * as libLocation from "../lib/location.ts";

function setOrientation(){
  const
    dataByPage = {
      'recipebox.php':{
        bodyClass:'print-flow'
      },
      'tasks.php':{
        orientation:'portrait',
        bodyClass:'print-flow'
      },
      'budget.php':{
        bodyClass:'print-flow'
      }
    }[libLocation.getPageName()]||{};

  if(dataByPage.orientation){
    var style = document.createElement('style')
    style.innerHTML = `@page {
  size :A4 ${dataByPage.orientation};
}`
    document.getElementById('container').appendChild(style);
  }

  if(dataByPage.bodyClass){
    document.body.setAttribute('class',dataByPage.bodyClass)
  } else{
    document.body.removeAttribute('class')
  }
}


window.addEventListener("beforeprint", (event) => {
  setOrientation()
})